import { Component, OnInit } from '@angular/core';

@Component({
	templateUrl: './nivel.component.html',
})

export class NivelComponent{
}
